/***
 * PC_F_01
 * importing the API functions fron DirectoryAPI
 */

import React from 'react';
import { useState, useEffect } from 'react';
import moment from 'moment';
import HRDisagreeFeedback from './HrDisagreeFeedback';
import EmpDisagreeFeedback from './EmpDisagreeFeedback';
import HrApproveFeedback from './HrApproveFeedbackForm';
import {
    getIndivigualEmpFeedback,
    getFlagCountAndName,
    postFeedbackResponse,
    getFeedbackAudit,
    getEmpReportsToAndRole,
    getReportingEmpId,
} from '../service/DirectorAPI';
import BreadCrumbs from '../components/BreadCrumbs/BreadCrumbs.jsx';
import { encryptStorage } from '../constant';
import { useNavigate } from 'react-router-dom';

/**
 * PC_TD_03 create a Feedback() function and it return the HTML
 *
 */
export function Feedback() {
    /***
     * PC_F_02
     * Declaring the state variables
     *
     */
    
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let emp_id = params.get('EmpId');
    let feedback_id = params.get('FeedbackId');
    let evaluation_id = params.get('EvaluationId');
    let isProfile = params.get('IsProfile');
    let isTeamMember = params.get('IsTeamMember');
    let flag = params.get('Flag');
    let isIndivigualfeedbackgrid = params.get('isIndivigualfeedbackgrid');
    let EmployeeStatus = params.get('Status');
    let rowID;
    let QueryString = ``;
    let login_emp_id = encryptStorage.getItem('employeeId');
    let role = encryptStorage.getItem('role');
    const [Feedbackdataid, setFeedbackdataid] = useState();

    const [flags, setFlags] = useState('');
    const [secondflag, setSecondFlags] = useState('');
    const [columnOrder, setColumnOrder] = useState('DESC');
    const [columnName, setColumnName] = useState('created_at');
    const [empResponse, setEmpResponse] = useState('');
    const [isHrApproveClick, setIsHrApproveClick] = useState(false);
    const [isHrDenyClick, setIsHrDenyClick] = useState(false);
    const [sorthide, setsorthide] = useState('');
    const [raisedBy, setRaisedBy] = useState('');
    const [empDisagreeClicked, setEmpDisagreeClicked] = useState(false);
    const [lastFeedbackRaiser, setLastFeedbackRaiser] = useState('');
    let feedbackCounts = 0;
    const navigate = useNavigate();

    let Indivigualfeedbackarray = [];
    const [indivigualfeedbackData, setIndivigualfeedbackData] = useState(Indivigualfeedbackarray);

    let IndivigualfeedbackAuditarray = [];
    const [indivigualfeedbackAuditData, setIndivigualfeedbackAuditData] = useState(IndivigualfeedbackAuditarray);

    let IndivFlagCounts = {
        green_flag: '',
        red_flag: '',
        yellow_flag: '',
        emp_name: '',
        domain: '',
        profile_img_url: '',
    };
    const [indivFlagCountsData, setIndivFlagCountsData] = useState(IndivFlagCounts);

    let currentFeedbackPersonInfo = {
        reportsTo: '',
        hrIncharge: '',
        role: '',
    };
    const [currFeedbackPersonData, setCurrFeedbackPersonData] = useState(currentFeedbackPersonInfo);

    let firstFeedbackRaiserInfo = {
        reportsTo: '',
        hrIncharge: '',
        role: '',
    };
    const [firstFeedbackRaiserData, setFirstFeedbackRaiserData] = useState(firstFeedbackRaiserInfo);

    /***
     * PC_F_03
     * UseEffect call the loadFlagCountPage, loadGridPage
     * loadAudiData functions to get the data from DB
     */
    useEffect(() => {
        loadFlagCountPage();
        loadGridPage();
        loadAudiData();
        getCurrentFeedbackPersonRole();
    }, [columnOrder, columnName]);

    /**
     * PC_F_04.3 this function get the feedback receiver reportsto and role and hr Incharge
     * by passing raiser id
     */
    const getCurrentFeedbackPersonRole = async () => {
        try {
            let empdata = {
                emp_id: emp_id,
            };
            let data = await getEmpReportsToAndRole(empdata);
            if (data.data != undefined && data.data != null && data.data.ResponseData[0].length != 0) {
                let PersonData = {
                    reportsTo: data.data.ResponseData[0][0].reports_to,
                    hrIncharge: data.data.ResponseData[0][0].hr_incharge,
                    role: data.data.ResponseData[0][0].name,
                };
                setCurrFeedbackPersonData(PersonData);
            }
        } catch (e) { }
    };

    /**
     * PC_F_04.4 this function get the feedback raiser reportsto, role and and hr Incharge
     * by passing raiser id
     */
    const getFirstFeedbackRaiserRole = async (raiserId) => {
        try {
            let empdata = {
                emp_id: raiserId,
            };
            let data = await getEmpReportsToAndRole(empdata);
            if (data.data != undefined && data.data != null && data.data.ResponseData[0].length != 0) {
                let PersonData = {
                    reportsTo: data.data.ResponseData[0][0].reports_to,
                    hrIncharge: data.data.ResponseData[0][0].hr_incharge,
                    role: data.data.ResponseData[0][0].name,
                };
                setFirstFeedbackRaiserData(PersonData);
            }
        } catch (e) { }
    };

    /***
     * PC_F_04
     * this function invock the getIndivigualEmpFeedback function api call
     */
    const loadGridPage = async () => {
        try {
            let empdata = {
                feedback_id: feedback_id,
                evaluation_id: evaluation_id,
                emp_id: emp_id,
                login_emp_id: login_emp_id,
            };
            let validReportTo = false;
            switch (encryptStorage.getItem('groupid')) {
                case '1': {
                    validReportTo = true;
                    break;
                }
                case '2': {
                    if (encryptStorage.getItem('employeeId') == emp_id) {
                        validReportTo = true;
                    } else {
                        let request = {
                            login_id: encryptStorage.getItem('employeeId'),
                        };
                        let respdata = await getReportingEmpId(request);

                        for (let i = 0; i < respdata.data.ResponseData[0]?.length; i++) {
                            if (respdata.data.ResponseData[0][i]?.emp_id === emp_id) {
                                validReportTo = true;
                            }
                            //
                        }
                    }
                    break;
                }
                case '3': {
                    if (emp_id == encryptStorage.getItem('employeeId')) validReportTo = true;
                    break;
                }
                default: {
                    navigate('*');
                    break;
                }
            }
            if (validReportTo) {
                let data = await getIndivigualEmpFeedback(empdata);
                setIndivigualfeedbackData(data.data.ResponseData[0]);
                let raiser_id = '';
                if (data.data != undefined && data.data != null && data.data.ResponseData[0].length != 0) {
                    setEmpResponse(data.data.ResponseData[0][0].emp_response);

                    let Index =
                        data.data.ResponseData[0].length > 0 ? data.data.ResponseData[0].length - 1 : data.data.ResponseData[0].length;
                    setRaisedBy(data.data.ResponseData[0][Index].created_by);
                    setLastFeedbackRaiser(data.data.ResponseData[0][0].created_by);
                    raiser_id = data.data.ResponseData[0][Index].created_by;

                    getFirstFeedbackRaiserRole(raiser_id);
                }
            } else {
                navigate('/', { state: { hideNav: false } });
            }
        } catch (e) { }
    };

    /***
     * PC_F_04.1
     * this function invock the loadAudiData function api call
     */

    const loadAudiData = async () => {
        try {
            let empdata = {
                feedback_id: feedback_id,
                evaluation_id: evaluation_id,
                emp_id: emp_id,
                sortColumn: columnName,
                sortOrder: columnOrder,
                login_emp_id: login_emp_id,
            };
            let data = await getFeedbackAudit(empdata);
            setIndivigualfeedbackAuditData(data.data.ResponseData[0]);
        } catch (e) { }
    };

    /***
     * PC_F_04.2
     * this function invock the loadFlagCountPage function api call
     */

    const loadFlagCountPage = async () => {
        try {
            let empdata = {
                feedback_id: feedback_id,
                evaluation_id: evaluation_id,
                emp_id: emp_id,
                login_emp_id: login_emp_id,
            };

            let data = await getFlagCountAndName(empdata);
            if (data.data != undefined && data.data != null && data.data.ResponseData[0].length != 0) {
                let IndivFlagCounts = {
                    green_flag: data.data.ResponseData[0].green_flag,
                    red_flag: data.data.ResponseData[0].red_flag,
                    yellow_flag: data.data.ResponseData[0].yellow_flag,
                    emp_name: data.data.ResponseData[0].emp_name,
                    domain: data.data.ResponseData[0].domain,
                    profile_img_url: data.data.ResponseData[0].profile_img_url,
                };

                setIndivFlagCountsData(IndivFlagCounts);
            }
        } catch (e) { }
    };

    /***
     * PC_F_11
     * this function post the employee response through
     * postFeedbackResponse api function
     */

    const EmployeeAgree = async () => {
        let feedbackdataid = indivigualfeedbackData[0].feedbackdataid;
        rowID = indivigualfeedbackData[0].feedbackdataid;
        let Flags = indivigualfeedbackData[0].flags;

        setFeedbackdataid(feedbackdataid);

        try {
            let empdata = {
                emp_response: 'Agreed',
                id: feedback_id,
                emp_id: emp_id,
                evaluation_id: evaluation_id,
                feedback_data_id: feedbackdataid,
                flags: Flags,
            };

            let data = await postFeedbackResponse(empdata);

            loadFlagCountPage();
            loadGridPage();
        } catch (e) { }
    };

    /***
     * PC_F_30
     * this function set the rowid and into the statevariable
     * to call the EmpDisagreeFeedback.jsx component
     */

    const employeeDisagree = () => {
        rowID = indivigualfeedbackData[0].feedbackdataid;
        setFeedbackdataid(rowID);
        setEmpDisagreeClicked(true);
    };

    /***
     * PC_F_28
     * this function set the feedbackid, flag type and into the statevariable
     * to call the HrApproveFeedback.jsx component
     */
    const HrApprove = () => {
        let feedbackid = indivigualfeedbackData[0].feedbackdataid;
        let Flags = indivigualfeedbackData[0].flags;
        setFeedbackdataid(feedbackid);
        setFlags(Flags);
        setIsHrApproveClick(true);
    };
    /**
     * PC_F_29 HrDeny function set the values into the variables
     * to call the HRDisagreeFeedback.jsx component
     */
    const HrDeny = () => {
        let Flags = indivigualfeedbackData[0].flags;
        let Flags2;

        if (indivigualfeedbackData.length > 1) {
            Flags2 = indivigualfeedbackData[1].flags;
            setSecondFlags(Flags2);
        }
        //let Flags1 = indivigualfeedbackData[1].flags;
        //
        setFlags(Flags);
        setIsHrDenyClick(true);
    };

    /**
     * PC_F_31 this Reload function reload the page after submitting the form
     */
    const Reload = () => {
        loadFlagCountPage();
        loadGridPage();
        loadAudiData();
    };

    /**
     * PC_F_32 value is setted based on redirection path
     */
    if (isProfile == 'true' && isTeamMember == 'true') {
        QueryString = `/profilecontainer?EmpId=${emp_id}&tab=feedback&IsTeamMember=true`;
    } else if (isProfile == 'true' && isTeamMember == undefined) {
        QueryString = `/profilecontainer?EmpId=${emp_id}&tab=feedback&Status=${EmployeeStatus}`;
    } else if (isIndivigualfeedbackgrid == 'true') {
        QueryString = `/indivigualfeedbackgrid?EmpId=${emp_id}&Flag=${flag}&emp_name=${indivFlagCountsData.emp_name}&emp_domain=${indivFlagCountsData.domain}&Status=${EmployeeStatus}`;
    } else {
        QueryString = `/FeedbackGrid?EmpId=${login_emp_id}`;
    }

    let breadCrumbsData;
    if ((role == 'Admin' || role == 'Hr Manager' || role == 'Hr' || role == 'Manager') && isProfile == 'true' && login_emp_id != emp_id) {
        breadCrumbsData = [
            { title: 'Dashboard', isActive: true, path: '/Overview' },
            { title: 'Team Member', isActive: true, path: '' },
            { title: 'Team Directory', isActive: true, path: '/TeamDirectory' },
            { title: indivFlagCountsData.emp_name, isActive: true, path: QueryString },
            { title: 'Feedback', isActive: false, path: '' },
        ];
    } else if (
        (role == 'Admin' || role == 'Hr Manager' || role == 'Hr' || role == 'Manager') &&
        isIndivigualfeedbackgrid == 'true' &&
        login_emp_id != emp_id
    ) {
        breadCrumbsData = [
            { title: 'Dashboard', isActive: true, path: '/Overview' },
            { title: 'Team Member', isActive: true, path: '' },
            { title: 'Team Directory', isActive: true, path: '/TeamDirectory' },
            { title: indivFlagCountsData.emp_name, isActive: true, path: '' },
            { title: 'Feedback', isActive: true, path: QueryString },
            { title: 'Feedback', isActive: false, path: '' },
        ];
    } else if (role == 'Team Member' || login_emp_id == emp_id) {
        breadCrumbsData = [
            { title: 'Dashboard', isActive: true, path: '/Overview' },
            { title: 'My Profile', isActive: true, path: QueryString },
            { title: 'Feedback', isActive: false, path: '' },
        ];
    } else if (role != 'Team Member' && isProfile != 'true' && isIndivigualfeedbackgrid != 'true' && login_emp_id != emp_id) {
        breadCrumbsData = [
            { title: 'Dashboard', isActive: true, path: '/Overview' },
            { title: 'Team Member', isActive: true, path: '' },
            { title: 'Feedback', isActive: true, path: QueryString },
            { title: 'Feedback', isActive: false, path: '' },
        ];
    }

    /***
     * PC_F_18
     * map and return the value
     */
    const buildIndivigualFeedbackBodyData = () => {
        try {
            return indivigualfeedbackData.map((obj, index) => {
                let m = moment(new Date(obj.created_at));
                let UpdatedDate = m.format('MMM DD, YYYY');
                let datalen = indivigualfeedbackData.length - 1;
                feedbackCounts = index + 1;
                let comments = obj.comments;

                return (
                    <div className={index == datalen ? 'row mt-5 mb-2 ' : 'row mt-5 mb-2 border-bottom'}>
                        <div className="col-md-2">
                            <label className="tt-bold font-14 mb-4 feedback-form-label">Flag Raised</label>
                            {obj.flags == 'G' ? (
                                <p className="feedback-text mb-0 semibold-text font-14">
                                    <span>
                                        <img src="/Images/Green-Flag.svg" className="pe-2" />
                                    </span>
                                    Green Flag
                                </p>
                            ) : null}
                            {obj.flags == 'R' ? (
                                <p className="feedback-text mb-0 semibold-text font-14">
                                    <span>
                                        <img src="/Images/red-flag.svg" className="pe-2" />
                                    </span>
                                    Red Flag
                                </p>
                            ) : null}
                            {obj.flags == 'Y' ? (
                                <p className="feedback-text mb-0 semibold-text font-14">
                                    <span>
                                        <img src="/Images/Yellow-Flag.svg" className="pe-2" />
                                    </span>
                                    Yellow Flag
                                </p>
                            ) : null}
                        </div>
                        <div className="col-md-3">
                            {index == datalen ? <label className="tt-bold font-14 mb-3 feedback-form-label">Raised by</label> : null}
                            {index != datalen ? <label className="tt-bold font-14 mb-3 feedback-form-label">Updated by</label> : null}
                            <div className="d-flex align-self-center">
                                <div>
                                    <img src="/Images/logo-person-user-person-icon.jpg" className="me-2 feedback-updatedby-img" alt="img" />
                                </div>
                                <div className="d-block  align-self-center">
                                    <p className="feedback-text semibold-text font-14 mt-2">{obj.updatedby}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2">
                            {index == datalen ? <label className="tt-bold font-14 mb-4 feedback-form-label">Raised Date</label> : null}
                            {index != datalen ? <label className="tt-bold font-14 mb-4 feedback-form-label">Updated On</label> : null}
                            <p className="feedback-text mb-0 semibold-text font-14">{UpdatedDate}</p>
                        </div>
                        <div className="col-md-4">
                            <label className="tt-bold font-14 mb-4 feedback-form-label">Feedback</label>
                            <p className="feedback-text mb-0 semibold-text font-14">{obj.comments_based_on}</p>
                        </div>
                        <div className="col-md-12">
                            <label className="semibold-text font-14 mb-2 my-5 feedback-form-label">Comments</label>
                            <p className="regular-text font-14 mb-4 feedback-form-label">
                                {' '}
                                <div dangerouslySetInnerHTML={{ __html: comments }}></div>
                            </p>
                        </div>
                        <div className="col-md-12 mb-3">
                            <label className="semibold-text font-14 mb-2 feedback-form-label">
                                {obj.emp_name} Comments
                                {obj.emp_response == 'Agreed' ? (
                                    <span className="feedback-agreed semibold-text ms-3 font-14">
                                        <img src="/Images/greed-pointer.svg" className="me-2" alt="green-pointer" />
                                        {obj.emp_response}
                                    </span>
                                ) : (
                                    <span className="feedback-denied semibold-text ms-3 font-14">
                                        <img src="/Images/red-pointer.svg" className="me-2" alt="red-pointer" />
                                        {obj.emp_response}
                                    </span>
                                )}
                            </label>
                            {obj.emp_comments ? <p className="regular-text font-14 mb-4 feedback-form-label">{obj.emp_comments}.</p> : null}

                            {obj.hr_response == 'Agreed' ? (
                                <label className="semibold-text font-14 mb-2 feedback-form-label"> HR Comment </label>
                            ) : null}
                            {obj.hr_response == 'Agreed' ? (
                                <span className="feedback-agreed semibold-text ms-3 font-14">
                                    <img src="/Images/greed-pointer.svg" className="me-2" alt="green-pointer" />
                                    Approved
                                </span>
                            ) : null}
                        </div>
                    </div>
                );
            });
        } catch (e) { }
    };

    /**
     *
     * PC_F_19 sort function set the column name and sort order in to the variable
     */

    const sortClicked = (e) => {
        try {
            let sortID = e.target.id;
            let sortval = sortID.split('@');

            setColumnName(sortval[0]);
            setColumnOrder(sortval[1]);
            setsorthide(sortID);
            //loadGridPage();
        } catch (error) { }
    };

    /***
     * PC_F_26
     * map function return the value
     */
    const buildAuditData = () => {
        try {
            return indivigualfeedbackAuditData.map((obj, index) => {
                let m = moment(new Date(obj.created_at));
                let FeeabackDate = m.format('MMM DD, YYYY');

                return (
                    <tr className="font-12 regular-text">
                        <td className="table-link-clr">{FeeabackDate}</td>
                        <td>{obj.emp_name}</td>
                        <td>{obj.action}</td>
                        <td>
                            <div dangerouslySetInnerHTML={{ __html: obj.comments }} />
                        </td>
                    </tr>

                );
            });
        } catch (e) {

        }
    };

    return (
        <div className="container-fluid coverpic mt-5">
            <div className="row justify-content-center ">
                <div className="col-md-8 p-4 mt-5 bg-white rounded-3">
                    <div className="align-middle mb-3">
                        <BreadCrumbs data={breadCrumbsData} />
                        <a href={QueryString} className title="Back">
                            <img src="/Images/back-arrow.svg" className=" me-2" alt="back-arrow" />
                        </a>
                        <span className="font-15 text-blue tt-bold mb-5">Feedback</span>
                    </div>
                    <div className="row ">
                        <div className="col-md-7 d-flex align-items-center">
                            <img src="/Images/logo-person-user-person-icon.jpg" className="feedback-profile-pic" alt="img" />
                            <div className="ps-3">
                                <h1 className="font-14 semibold-text team-member-name mb-1">{indivFlagCountsData.emp_name}</h1>
                                <p className=" font-14 pb-0 pt-1 regular-text my-0">{indivFlagCountsData.domain}</p>
                            </div>
                        </div>
                        <div className="col-md-4 ">
                            <div className="row border-0 shadow py-3">
                                <div className="col-md-4 text-center">
                                    <img src="/Images/green-flag-withbg.svg" alt="green-flag" />
                                    <p className="tt-bold mb-0 pt-1 feedback-form-label text-center font-16">
                                        {indivFlagCountsData.green_flag ? indivFlagCountsData.green_flag : 0}
                                    </p>
                                </div>
                                <div className="col-md-4 text-center">
                                    <img src="/Images/yellow-flag-withbg.svg" alt="yellow-flag" />
                                    <p className="tt-bold mb-0 pt-1 feedback-form-label text-center font-16">
                                        {indivFlagCountsData.yellow_flag ? indivFlagCountsData.yellow_flag : 0}
                                    </p>
                                </div>
                                <div className="col-md-4 text-center">
                                    <img src="/Images/red-flag-withbg.svg" alt="red-flag" />
                                    <p className="tt-bold mb-0 pt-1 feedback-form-label text-center font-16">
                                        {indivFlagCountsData.red_flag ? indivFlagCountsData.red_flag : 0}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {buildIndivigualFeedbackBodyData()}

                    <div className="modal-footer border-0">
                        <a href={QueryString}>
                            <button type="button" className="btn hive-btn-secondary">
                                Back
                            </button>
                        </a>

                        {/* PC_F_32.1 validating the role and status */}
                        {emp_id == login_emp_id && (empResponse == 'pending' || empResponse == 'Pending') ? (
                            <button
                                type="button"
                                className="btn  leave-reject-button"
                                data-bs-toggle="modal"
                                data-bs-target="#EmpDisagreeFeedbackPopup"
                                hidden={feedbackCounts >= 3 ? true : false}
                                onClick={() => employeeDisagree()}
                            >
                                Disagree
                            </button>
                        ) : null}
                        {emp_id == login_emp_id && (empResponse == 'pending' || empResponse == 'Pending') ? (
                            <button type="button" className="btn hive-btn-primary" onClick={() => EmployeeAgree()}>
                                Agree
                            </button>
                        ) : null}

                        {/* PC_F_32.2 here validating the feedback got person role and show the deny and approve button to hr manager 
            if the person is manager, Team Memberthe below button is shown*/}
                        {/*  && raisedBy != login_emp_id */}

                        {currFeedbackPersonData.role == 'Manager' || currFeedbackPersonData.role == 'Team Member' ? ( //&& currFeedbackPersonData.hrIncharge == login_emp_id
                            (role == 'Hr Manager' ||
                                (role == 'Hr' &&
                                    currFeedbackPersonData.hrIncharge == login_emp_id &&
                                    lastFeedbackRaiser != login_emp_id)) &&
                                emp_id != login_emp_id &&
                                empResponse == 'Disagree' ? (
                                <button
                                    type="button"
                                    className="btn leave-reject-button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#HrDisagreeFeedbackPopup"
                                    onClick={() => HrDeny()}
                                >
                                    Deny
                                </button>
                            ) : null
                        ) : null}

                        {currFeedbackPersonData.role == 'Manager' || currFeedbackPersonData.role == 'Team Member' ? ( // && currFeedbackPersonData.hrIncharge == login_emp_id
                            (role == 'Hr Manager' ||
                                (role == 'Hr' &&
                                    currFeedbackPersonData.hrIncharge == login_emp_id &&
                                    lastFeedbackRaiser != login_emp_id)) &&
                                emp_id != login_emp_id &&
                                empResponse == 'Disagree' ? (
                                <button
                                    type="button"
                                    className="btn hive-btn-primary "
                                    data-bs-toggle="modal"
                                    data-bs-target="#HrApproveFeedbackPopup"
                                    onClick={() => HrApprove()}
                                >
                                    Approve
                                </button>
                            ) : null
                        ) : null}

                        {/* PC_F_32.3 here validating the feedback got person role and show the deny and approve button to hr manager
            if the person is Hr Manager, Hr  below button is shown */}

                        {currFeedbackPersonData.role == 'Hr Manager' || currFeedbackPersonData.role == 'Hr' ? (
                            role == 'Hr Manager' &&
                                emp_id != login_emp_id &&
                                login_emp_id == firstFeedbackRaiserData.reportsTo &&
                                empResponse == 'Disagree' ? (
                                <button
                                    type="button"
                                    className="btn leave-reject-button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#HrDisagreeFeedbackPopup"
                                    onClick={() => HrDeny()}
                                >
                                    Deny
                                </button>
                            ) : null
                        ) : null}

                        {currFeedbackPersonData.role == 'Hr Manager' || currFeedbackPersonData.role == 'Hr' ? (
                            role == 'Hr Manager' &&
                                emp_id != login_emp_id &&
                                login_emp_id == firstFeedbackRaiserData.reportsTo &&
                                empResponse == 'Disagree' ? (
                                <button
                                    type="button"
                                    className="btn hive-btn-primary "
                                    data-bs-toggle="modal"
                                    data-bs-target="#HrApproveFeedbackPopup"
                                    onClick={() => HrApprove()}
                                >
                                    Approve
                                </button>
                            ) : null
                        ) : null}
                    </div>
                </div>
                {role != 'Team Member' && login_emp_id != emp_id ? (
                    <div className="col-md-8 px-0 mt-5 mb-5 rounded-3">
                        {/*Audit history strats here*/}
                        <h5 className="font-15 bold-text feedback-form-label mb-3">Audit History</h5>
                        <div className="table-responsive  ">
                            <table className="table bg-white hive-grid table-borderless">
                                <thead className="hive-table-head">
                                    <tr className>
                                        <th className="bold-text font-12">
                                            Date and Time
                                            <span>
                                                <a>
                                                    <img
                                                        className="sort-icon p-1"
                                                        src="/Images/Sort-up.svg"
                                                        alt="sort-icon"
                                                        id="feedback_audit.created_at@ASC"
                                                        onClick={(e) => sortClicked(e)}
                                                        hidden={sorthide == 'feedback_audit.created_at@ASC' ? true : false}
                                                    />
                                                    <img
                                                        className="sort-icon p-1"
                                                        src="/Images/sort-icon.svg"
                                                        alt="sort-icon"
                                                        id="feedback_audit.created_at@DESC"
                                                        onClick={(e) => sortClicked(e)}
                                                        hidden={sorthide == 'feedback_audit.created_at@ASC' ? false : true}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th className="bold-text font-12">User Name</th>
                                        <th className="bold-text font-12">Action</th>
                                        <th className="bold-text font-12">Comments</th>
                                    </tr>
                                </thead>
                                <tbody>{buildAuditData()}</tbody>
                            </table>
                        </div>
                        {/*Audit history ends here*/}
                    </div>
                ) : null}
            </div>
            {/* PC_F_28,PC_F_29,PC_F_30 HRDisagreeFeedback is called from HrDisagreeFeedback.jsx component   */}
            <HRDisagreeFeedback
                empId={emp_id}
                FeedbackId={feedback_id}
                Flag={flags}
                Secondflag={secondflag}
                EvaluationId={evaluation_id}
                isHrDenyClicked={isHrDenyClick}
                setIsHrDenyClick={() => setIsHrDenyClick()}
                Reload={() => Reload()}
            />
            <EmpDisagreeFeedback
                empId={emp_id}
                FeedbackId={feedback_id}
                EvaluationId={evaluation_id}
                Flag={flags}
                feedbackDataID={Feedbackdataid}
                Reload={() => Reload()}
                EmpDisagreeClicked={empDisagreeClicked}
                setEmpDisagreeClicked={() => setEmpDisagreeClicked()}
            />
            <HrApproveFeedback
                empId={emp_id}
                FeedbackId={feedback_id}
                EvaluationId={evaluation_id}
                Flag={flags}
                feedbackDataID={Feedbackdataid}
                isHrApproveClicked={isHrApproveClick}
                Reload={() => Reload()}
                setIsHrApproveClick={() => setIsHrApproveClick()}
            />
        </div>
    );
}
export default Feedback;
